import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class MediaReferenceService {
  private readonly apiService = inject(ApiService);

  getMediaReferenceDownloadLink(mediaReferenceId: number): Observable<string> {
    const resourceUrl = `mediareference/${mediaReferenceId}/link`;
    return this.apiService.getText(resourceUrl);
  }
}
